<template>
    <div class="guidance">
        {{ text }}
    </div>
</template>

<script>
    export default {
        name: 'Guidance',
        props: {
            text: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
.guidance {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    color: rgba(var(--v-theme-secondary), 0.8);
}

@media (max-width: 1800px) {
    .guidance {
        font-size: 1.3rem;
    }
}

@media (max-width: 1200px) {
    .guidance {
        font-size: 1.2rem;
    }
}

@media (max-width: 800px) {
    .guidance {
        font-size: 1.1rem;
    }
}

@media (max-width: 600px) {
    .guidance {
        font-size: 1.0rem;
    }
}
</style>